import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/common/PageHeader";
import { EmptyState } from "@/components/common/EmptyState";
import { SurfaceCard } from "@/components/common/Cards";
import { StatusBadge } from "@/components/common/StatusBadge";
import { relativeDay } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { BellRing, Check } from "lucide-react";
import { toast } from "sonner";

export default function FollowUps() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/followups").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);
  const complete = async (f) => { await api.put(`/followups/${f.id}`, { status: "completed" }); toast.success("Follow-up completed"); load(); };

  return (
    <div>
      <PageHeader title="Follow-ups" subtitle="Track post-treatment and recall follow-ups" breadcrumb={["Practice", "Follow-ups"]} />
      {items && items.length === 0 ? (
        <EmptyState icon={BellRing} title="No follow-ups" description="Follow-up reminders from clinical workflows will appear here." testId="followups-empty" />
      ) : (
        <div className="space-y-3">
          {(items || []).map((f) => (
            <SurfaceCard key={f.id} className="p-4">
              <div className="flex items-center gap-4">
                <div className={`flex h-10 w-10 items-center justify-center rounded-xl ${f.status === "overdue" ? "bg-red-50 text-red-500 dark:bg-red-500/15" : "bg-[#E8F7F0] text-[#00A85A] dark:bg-[#00A85A]/15"}`}><BellRing className="h-4 w-4" /></div>
                <div className="flex-1 min-w-0"><div className="text-sm font-bold text-[#101516] dark:text-white">{f.patient_name}</div><div className="text-xs text-[#8B9698] truncate">{f.note} · Due {relativeDay(f.due_date)}</div></div>
                <StatusBadge status={f.status} />
                {f.status !== "completed" && <Button size="sm" onClick={() => complete(f)} data-testid={`complete-followup-${f.id}`} className="h-8 bg-[#00A85A] hover:bg-[#008F4D] text-white rounded-lg"><Check className="h-3.5 w-3.5 mr-1" />Done</Button>}
              </div>
            </SurfaceCard>
          ))}
        </div>
      )}
    </div>
  );
}
